import React, { useContext, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';

const Logout = () => {
    const { logoutUser } = useContext(AuthContext);

    useEffect(() => {
        
        // 1. Limpieza específica del Chat AI
        localStorage.removeItem('chat_messages');
        localStorage.removeItem('chat_isOpen');
        localStorage.removeItem('chat_userId');

        // 2. Ejecutar la función de logout normal de tu AuthContext
        if (logoutUser) {
            logoutUser();
        } else {
            console.error('[LOGOUT DEBUG] logoutUser no está definido en AuthContext');
        }
    }, []); 
    return <Redirect to="/Login" />;
}

export default Logout;